/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_Ninjaone1Inputs */



/**
* | output |
* | --- |
* | "NinjaOne" |
*
* @param {Spaces_Provider_Ninjaone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_provider_ninjaone1 = /** @type {((inputs?: Spaces_Provider_Ninjaone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Ninjaone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("NinjaOne")
	return /** @type {LocalizedString} */ ("NinjaOne")
});
export { spaces_provider_ninjaone1 as "spaces_provider_ninjaOne" }